import React from 'react';
import SubmissionsStatus from './SubmissionsStatus';
import SubmissionRecent from './SubmissionRecent';
import { useTranslation } from 'react-i18next';

const Dashboard: React.FC = () => {
  const { t } = useTranslation('dashboard');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title.title')}</h6>
      <SubmissionsStatus />
      <SubmissionRecent />
    </section>
  );
};

export default Dashboard;
